import axios from "axios";

const delinquentPartnersUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients/delinquent-partners`;

export const getDelinquentPartners = async (
  token,
  { qxCna, page = 0, size = 10 } = {},
  displayError = () => {}
) => {
  const query = new URLSearchParams();
  if (qxCna !== undefined && qxCna !== null && qxCna !== "")
    query.append("search", qxCna);
  query.append("page", page);
  query.append("size", size);

  return await axios
    .get(`${delinquentPartnersUrl}?${query.toString()}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (token)
        displayError("getDelinquentPartners error: " + error.message);
    });
};

// El endpoint de excel usa "search" en vez de "qxCna" como parámetro de filtro.
export const downloadDelinquentPartnersExcel = async (
  token,
  { qxCna } = {},
  displayError = () => {}
) => {
  const query = new URLSearchParams();
  if (qxCna !== undefined && qxCna !== null && qxCna !== "")
    query.append("search", qxCna);

  return await axios
    .get(`${delinquentPartnersUrl}/excel?${query.toString()}`, {
      headers: { authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      const disposition = response.headers["content-disposition"];
      const match = disposition && disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : "socios-morosos.xlsx";

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      if (token)
        displayError("downloadDelinquentPartnersExcel error: " + error.message);
    });
};
